import $ = require('jquery');

function cookieLaw() {
    //Cookie law
    var acceptCookiesContainer = $("#acceptCookiesContainer");
    acceptCookiesContainer.addClass('show');
    $("#acceptCookies").click(function () {
        createCookie("accept-cookies", '1', 365);
        acceptCookiesContainer.remove();
    });
}

function createCookie(name: string, value: string, days: number) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toUTCString();
    }
    else expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
}

export = cookieLaw;


// WEBPACK FOOTER //
// ./ToxicVentures.Umbraco/Content/Ts/cookie-law.ts